import { DOCUMENT } from '@angular/common';
import { Injectable, inject } from '@angular/core';

@Injectable({
  providedIn: 'root',
})
export class ExportService {
  private $document = inject<Document>(DOCUMENT);


  export(filename: string, data: string | Blob, type = 'text/csv;charset=utf-8;') {
    const blob = typeof data === 'string' ? new Blob(['\ufeff', data], { type }) : data;
    const url = URL.createObjectURL(blob);
    this.download(filename, url);
    URL.revokeObjectURL(url);
  }

  download(filename: string, url: string, target = '') {
    const link = this.$document.createElement('a');
    link.setAttribute('href', url);
    link.setAttribute('download', filename);
    link.setAttribute('target', target);
    link.style.visibility = 'hidden';
    this.$document.body.appendChild(link);
    link.click();
    this.$document.body.removeChild(link);
  }
}
